import React, { Component } from 'react';
import './Login.css';
import { toast, ToastContainer } from 'react-toastify'; // Import ToastContainer
import 'react-toastify/dist/ReactToastify.css';
import emailjs from '@emailjs/browser';
import { withTranslation } from "react-i18next";

class ContactForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nome: '',
            azienda: '',
            email: '',
            messaggio: '',

        };
        this.onChange = this.onChange.bind(this);
        this.sendEmail = this.sendEmail.bind(this); // Bind sendEmail
    }

    onChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    sendEmail(e) {
        e.preventDefault(); // Prevent the default form submission behavior
        // Show loading indicator
        const { t } = this.props;
        toast.info(t('pages.toast.ts1'), { autoClose: 1000 });
        // Send email using EmailJS
        emailjs.sendForm('service_u317szf', 'template_4appmns', e.target, 'Xl4cHzs5_rTnbe391')
            .then((result) => {
                // Display success message
                toast.success(t('pages.toast.ts2'), { autoClose: 2000 });
                e.target.reset(); // Reset form fields
                this.setState({ email: '' }); // Clear email state
            }, (error) => {
                console.error(error.text);
                // Display error message
                toast.error(t('pages.toast.ts3'), { autoClose: 2000 });
            });
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                <ToastContainer /> {/* Include ToastContainer for notifications */}
                <div className="main-wrapper-login">
                  <div className="tools-wrapperS1-login">
                    <div className="login-block">
                    <h3 className="preview-title">{t('pages.login.l8')} </h3>
                        <form onSubmit={this.sendEmail}>
                            <div>
                                <input
                                    type="text"
                                    placeholder="Name"
                                    name="nome"
                                    value={this.state.nome}
                                    onChange={this.onChange}
                                    required
                                />
                            </div>
                            <div>
                                <input
                                    type="text"
                                    placeholder="Enter your company"
                                    name="azienda" // Use lowercase for consistency
                                    value={this.state.azienda}
                                    onChange={this.onChange}
                                />
                            </div>
                            <div>
                                <input
                                    type="email"
                                    placeholder="Email"
                                    name="email"
                                    value={this.state.email}
                                    onChange={this.onChange}
                                    required
                                />
                            </div>

                            <div>
                            <textarea
                                placeholder="Your Message"
                                name="message"
                                value={this.state.message}
                                onChange={this.onChange}
                                required
                            />
                           </div>

                            <button
                                type="submit"
                                className="btn-block"
                                style={{ maxWidth: '300px' }}
                            >
                                {t('pages.register.r5')}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
           </div>
        );
    }
}

export default withTranslation()(ContactForm);

